enum CommitteeChamber {
  House = 'house',
  Senate = 'senate',
  Joint = 'joint',
}

export default CommitteeChamber;
